import { RouteObject } from 'react-router-dom';
import Checkout from '~/pages/Subscription/Checkout';
import Subscription from '~/pages/Subscription';
import RequireAuth from '~/components/auth/RequireAuth';
import AuthLayout from '~/components/auth/AuthLayout';

const routes: RouteObject[] = [
  { index: true, element: <Subscription /> },
  {
    path: ':id/checkout',
    element: (
      <RequireAuth>
        <AuthLayout />
      </RequireAuth>
    ),
    children: [{ index: true, element: <Checkout /> }],
  },
];

export default routes;
